var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_162_50780)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.52 21.4302C23.2829 21.5137 22.9963 21.5723 22.6339 21.5723C21.8957 21.5723 20.7609 21.3707 19.9752 20.7515C19.1894 21.3707 18.0552 21.5723 17.3169 21.5723C16.5787 21.5723 15.4445 21.3707 14.6582 20.7515C13.8725 21.3707 12.7382 21.5723 12 21.5723C11.2617 21.5723 10.1275 21.3707 9.34126 20.7515C8.5555 21.3707 7.42126 21.5723 6.68302 21.5723C5.94478 21.5723 4.81054 21.3707 4.02478 20.7515C3.23902 21.3707 2.1043 21.5723 1.36606 21.5723C1.03486 21.5723 0.74638 21.5425 0.47998 21.5017",
    stroke: "#008934",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.52 23.3502C23.2829 23.4337 22.9963 23.4923 22.6339 23.4923C21.8957 23.4923 20.7609 23.2907 19.9752 22.6715C19.1894 23.2907 18.0552 23.4923 17.3169 23.4923C16.5787 23.4923 15.4445 23.2907 14.6582 22.6715C13.8725 23.2907 12.7382 23.4923 12 23.4923C11.2617 23.4923 10.1275 23.2907 9.34126 22.6715C8.5555 23.2907 7.42126 23.4923 6.68302 23.4923C5.94478 23.4923 4.81054 23.2907 4.02478 22.6715C3.23902 23.2907 2.1043 23.4923 1.36606 23.4923C1.03486 23.4923 0.74638 23.4625 0.47998 23.4217",
    stroke: "#008934",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.1202 14.9041C21.1202 15.3452 20.6791 15.3601 20.6791 15.3601H19.7119C19.7119 15.3601 19.2002 15.3313 19.2002 14.8902C19.2002 14.6334 19.2002 14.2633 19.2002 14.2633C19.2002 14.2633 19.2165 14.078 19.5136 14.078C19.8112 14.078 19.84 14.2633 19.84 14.2633V14.6473C19.84 14.6473 19.8698 14.833 20.1535 14.833C20.4372 14.833 20.4804 14.6473 20.4804 14.6473V14.2633C20.4804 14.2633 20.5101 14.078 20.8077 14.078C21.1058 14.078 21.1202 14.2633 21.1202 14.2633C21.1202 14.2633 21.1202 14.6622 21.1202 14.9041Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6077 12.424L14.4001 7.68018H10.5601L9.60007 10.5602H7.20007L4.80007 7.68018H2.88007L3.84007 10.0802L2.21143 12.5099",
    stroke: "#008934",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3 12.9601H17.46",
    stroke: "#008934",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.6686 21.2785C18.9753 20.6468 22.547 17.8537 23.4859 13.6479C23.5435 13.3854 23.5421 13.0955 23.3741 12.8862C23.2051 12.6759 22.8297 12.4801 22.56 12.4801H18.24L16.32 15.3601H3.35998L2.39998 12.4801H1.43998C0.9499 12.4801 0.47998 12.9505 0.47998 13.4401V16.0988C0.47998 18.5454 1.99486 20.2009 3.42382 20.9531",
    stroke: "#008934",
    strokeWidth: 0.961008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.75977 10.5602H16.8201",
    stroke: "#008934",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_50780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.43c93e8931584d386d9d4d64a37efb95.svg";
export { ForwardRef as ReactComponent };